interface GetInvitation {
    organizationName: string;
    inviterName: string;
    email: string;
    hasShare: boolean;
    shareExists: boolean;
    uuid: string;
}

export interface GetInvitationDto extends Readonly<GetInvitation> {}
